/* Torx theme JS ---------------------------------------------------------- */
(function () {
  'use strict';
  var T = window.Torx || {};

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '£{{amount}}';
    cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
    function delim(n, prec, thou, dec) {
      thou = thou || ','; dec = dec || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return dollars + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return delim(cents, 2);
        case 'amount_no_decimals': return delim(cents, 0);
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        default: return delim(cents, 2);
      }
    });
  }
  T.formatMoney = formatMoney;

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Header: mobile menu + search ---------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-toggle'));
    if (!target) return;
    var open = target.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open);
    if (open) { var inp = $('input', target); if (inp) inp.focus(); }
  });

  /* Quantity steppers ---------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min || '0', 10);
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart drawer ---------------------------------------------------------- */
  var drawer = $('#CartDrawer');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var c = $('.drawer__head button', drawer); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && T.cartType === 'drawer' && drawer) { e.preventDefault(); refreshCart().then(openDrawer); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function shipBar(total) {
    var th = T.freeShippingThreshold || 0;
    if (!th) return '';
    var pct = Math.min(100, Math.round((total / th) * 100));
    var text = total >= th
      ? 'Free shipping unlocked'
      : 'You\'re <strong>' + formatMoney(th - total) + '</strong> away from free shipping';
    return '<div class="ship-bar"><div class="ship-bar__text">' + text + '</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    var body = $('.drawer__body', drawer);
    var foot = $('.drawer__foot', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn" href="' + (T.routes.root_url || '/') + 'collections/all">Shop all products</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    var html = shipBar(cart.total_price);
    cart.items.forEach(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + esc(item.variant_title) + '</div>' : '';
      var disc = (item.line_level_discount_allocations || []).map(function (d) {
        return '<div class="cart-line__disc">' + esc(d.discount_application.title) + ' (-' + formatMoney(d.amount) + ')</div>';
      }).join('');
      var price = item.final_line_price < item.original_line_price
        ? '<span class="price price--sale">' + formatMoney(item.final_line_price) + '</span><br><s class="price" style="color:var(--c-muted);font-weight:400;font-size:.8em">' + formatMoney(item.original_line_price) + '</s>'
        : '<span class="price">' + formatMoney(item.final_line_price) + '</span>';
      html += '<div class="cart-line">' +
        '<a class="cart-line__img" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div><a class="cart-line__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' + variant + disc +
        '<div class="cart-line__controls"><div class="qty"><button type="button" data-qty="minus" aria-label="Decrease">&minus;</button>' +
        '<input type="number" min="0" value="' + item.quantity + '" data-line="' + (i + 1) + '" aria-label="Quantity"><button type="button" data-qty="plus" aria-label="Increase">+</button></div>' +
        '<button type="button" class="link-btn" data-remove="' + (i + 1) + '">Remove</button></div></div>' +
        '<div style="text-align:right">' + price + '</div></div>';
    });
    body.innerHTML = html;
    var cartDiscounts = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<div class="cart-summary" style="font-weight:400;font-size:.9rem;margin:.25rem 0"><span>' + esc(d.title) + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></div>';
    }).join('');
    $('[data-cart-discounts]', foot).innerHTML = cartDiscounts;
    $('[data-cart-total]', foot).textContent = formatMoney(cart.total_price);
  }

  function refreshCart() {
    return fetch((T.routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }
  T.refreshCart = refreshCart;

  function changeLine(line, qty) {
    return fetch((T.routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawer) {
    drawer.addEventListener('change', function (e) {
      var inp = e.target.closest('input[data-line]');
      if (inp) changeLine(parseInt(inp.getAttribute('data-line'), 10), parseInt(inp.value, 10) || 0);
    });
    drawer.addEventListener('click', function (e) {
      var r = e.target.closest('[data-remove]');
      if (r) changeLine(parseInt(r.getAttribute('data-remove'), 10), 0);
    });
  }

  /* Add to cart (product forms + quick add) ------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || T.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding&hellip;'; }
    var err = form.querySelector('[data-form-error]');
    if (err) err.textContent = '';
    fetch((T.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        return refreshCart().then(openDrawer);
      })
      .catch(function (ex) { if (err) err.textContent = ex.message; else alert(ex.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* Product page --------------------------------------------------------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('script[data-product-json]', root);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = $('form[data-ajax-cart]', root);
    var idInput = form && $('input[name="id"]', form);
    var btn = form && $('[type="submit"]', form);
    var priceEl = $('[data-price]', root);
    var stockEl = $('[data-stock]', root);
    var skuEl = $('[data-sku]', root);
    var mainImg = $('[data-main-media] img', root);
    var qtyInput = form && $('input[name="quantity"]', form);
    var addLabel = btn ? btn.getAttribute('data-add-label') : 'Add to cart';
    var soldLabel = btn ? btn.getAttribute('data-sold-label') : 'Sold out';

    function currentOptions() {
      return $$('.variant-group', root).map(function (g) {
        var c = $('input:checked', g); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateAvailability(opts) {
      $$('.variant-group', root).forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var v = findVariant(test);
          var lab = root.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = currentOptions();
      var v = findVariant(opts);
      updateAvailability(opts);
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        if (v.compare_at_price > v.price) {
          var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          priceEl.innerHTML = '<span class="price price--sale">' + formatMoney(v.price) + '</span><s class="price">' + formatMoney(v.compare_at_price) + '</s><span class="save-pill">Save ' + pct + '%</span>';
        } else {
          priceEl.innerHTML = '<span class="price">' + formatMoney(v.price) + '</span>';
        }
      }
      var sp = $('[data-sticky-price]', root); if (sp) sp.textContent = formatMoney(v.price);
      var sb = $('[data-sticky-btn]', root); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? addLabel : soldLabel; }
      if (skuEl) skuEl.textContent = v.sku || '—';
      if (btn) { btn.disabled = !v.available; btn.innerHTML = v.available ? addLabel : soldLabel; }
      if (stockEl) {
        var cls = 'stock', txt = stockEl.getAttribute('data-in');
        if (!v.available) { cls += ' stock--out'; txt = stockEl.getAttribute('data-out'); }
        stockEl.className = cls;
        $('span:last-child', stockEl).textContent = txt;
      }
      if (v.featured_media && mainImg) {
        mainImg.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        mainImg.removeAttribute('srcset');
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('torx:variant', { detail: v, bubbles: true }));
    }
    root.addEventListener('change', function (e) { if (e.target.closest('.variant-group')) update(); });

    // Gallery thumbs
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-thumb');
        mainImg.removeAttribute('srcset');
        $$('[data-thumb]', root).forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    // Bundle boxes
    var vol = $('[data-volume]', root);
    if (vol && qtyInput) {
      var tiers = $$('.bundle', vol);
      function priceTiers(price) {
        tiers.forEach(function (t) {
          var off = parseFloat(t.getAttribute('data-off')) || 0;
          var q = parseInt(t.getAttribute('data-tier-qty'), 10) || 1;
          var each = Math.floor(price * (100 - off) / 100);
          var e = $('[data-each]', t), tot = $('[data-total]', t), full = $('[data-full]', t);
          if (e) e.textContent = formatMoney(each);
          if (tot) tot.textContent = formatMoney(each * q);
          if (full) full.textContent = formatMoney(price * q);
        });
      }
      function highlight() {
        var q = parseInt(qtyInput.value, 10) || 1, active = null;
        tiers.forEach(function (t) { if (q >= parseInt(t.getAttribute('data-tier-qty'), 10)) active = t; });
        tiers.forEach(function (t) {
          var on = t === active;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      tiers.forEach(function (t) {
        t.addEventListener('click', function () { qtyInput.value = t.getAttribute('data-tier-qty'); highlight(); });
      });
      qtyInput.addEventListener('change', highlight);
      qtyInput.addEventListener('input', highlight);
      root.addEventListener('torx:variant', function (e) { priceTiers(e.detail.price); });
      highlight();
    }

    // Lab result modal
    var labModal = $('[data-lab-modal]', root);
    if (labModal) {
      $$('[data-lab-open]', root).forEach(function (b) {
        b.addEventListener('click', function () { if (labModal.showModal) labModal.showModal(); else labModal.setAttribute('open', ''); });
      });
      labModal.addEventListener('click', function (e) {
        if (e.target === labModal || e.target.closest('[data-lab-close]')) labModal.close();
      });
    }

    // "Or £x each when you buy 3+"
    var fromEl = $('[data-from-each]', root);
    if (fromEl) {
      var lastBundle = $$('.bundle', root).pop();
      root.addEventListener('torx:variant', function (e) {
        var off = lastBundle ? parseFloat(lastBundle.getAttribute('data-off')) || 0 : 0;
        fromEl.textContent = formatMoney(Math.floor(e.detail.price * (100 - off) / 100));
      });
    }
  });


  /* Sticky add-to-cart -------------------------------------------------- */
  var sticky = $('[data-sticky-atc]');
  var anchor = $('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(anchor);
  }

  /* Delivery timeline (UK time, Mon-Fri dispatch) ----------------------- */
  var deliv = $('[data-delivery]');
  if (deliv) {
    var cutoff = parseInt(deliv.getAttribute('data-cutoff'), 10) || 14;
    var dMin = parseInt(deliv.getAttribute('data-min'), 10) || 1;
    var dMax = parseInt(deliv.getAttribute('data-max'), 10) || 2;
    var tEl = $('[data-dispatch-time]', deliv), dayEl = $('[data-dispatch-day]', deliv);
    var stD = $('[data-step-dispatch]', deliv), stV = $('[data-step-deliver]', deliv);
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function ukParts() {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, mo: +o.month - 1, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
    }
    function isWork(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6; }
    function addWork(dt, n) { var x = new Date(dt); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isWork(x)) n--; } return x; }
    function fmt(dt) { return DAYS[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MON[dt.getUTCMonth()]; }
    function tick() {
      var u = ukParts();
      var today = new Date(Date.UTC(u.y, u.mo, u.d));
      var nowS = u.h * 3600 + u.mi * 60 + u.s, cutS = cutoff * 3600;
      var disp = new Date(today), secs;
      if (isWork(today) && nowS < cutS) { secs = cutS - nowS; }
      else {
        disp = addWork(today, 1);
        var days = Math.round((disp - today) / 86400000);
        secs = days * 86400 - nowS + cutS;
      }
      var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60);
      tEl.textContent = h >= 24 ? Math.floor(h / 24) + 'd ' + (h % 24) + 'h' : (h > 0 ? h + 'h ' : '') + m + 'm';
      var diff = Math.round((disp - today) / 86400000);
      dayEl.textContent = diff === 0 ? 'today' : diff === 1 ? 'tomorrow' : 'on ' + DAYS[disp.getUTCDay()];
      stD.textContent = diff === 0 ? 'Today' : fmt(disp);
      var a = addWork(disp, dMin), b = addWork(disp, dMax);
      stV.textContent = dMin === dMax ? fmt(a) : fmt(a).replace(/ \w+$/, a.getUTCMonth() === b.getUTCMonth() ? '' : ' ' + MON[a.getUTCMonth()]) + ' - ' + fmt(b);
    }
    tick(); setInterval(tick, 30000);
  }

  /* Reveal on scroll ---------------------------------------------------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Quick-add popup (product cards) ------------------------------------ */
  var qa = document.getElementById('QuickAdd');
  if (qa) {
    var QA = { product: null, variant: null, qty: 1, opts: [] };
    var qs = function (sel) { return qa.querySelector(sel); };
    function tiers() {
      return (T.tiers || '').split(',').map(function (t) {
        var p = t.trim().split(':'); return { q: parseInt(p[0], 10) || 1, off: parseFloat(p[1]) || 0 };
      }).filter(function (t) { return t.q > 0; });
    }
    function unitWord(n) { return n === 1 ? (QA.unit || T.unit || 'bottle') : (QA.units || T.units || 'bottles'); }
    function imgUrl(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function step(name) {
      $$('[data-qa-step]', qa).forEach(function (el) { el.hidden = el.getAttribute('data-qa-step') !== name; });
    }
    function openQA() { if (qa.showModal) qa.showModal(); else qa.setAttribute('open', ''); document.body.classList.add('no-scroll'); }
    function closeQA() { qa.close ? qa.close() : qa.removeAttribute('open'); }
    qa.addEventListener('close', function () { document.body.classList.remove('no-scroll'); });
    qa.addEventListener('click', function (e) {
      if (e.target === qa || e.target.closest('[data-qa-close]')) { e.preventDefault(); closeQA(); }
    });

    function findVariant() {
      var p = QA.product;
      return p.variants.find(function (v) { return v.options.every(function (o, i) { return o === QA.opts[i]; }); }) || null;
    }
    function renderPrice() {
      var v = QA.variant;
      var el = qs('[data-qa-price]');
      if (!v) { el.textContent = 'Unavailable'; return; }
      el.innerHTML = v.compare_at_price > v.price
        ? '<span class="price price--sale">' + formatMoney(v.price) + '</span><s>' + formatMoney(v.compare_at_price) + '</s>'
        : '<span class="price">' + formatMoney(v.price) + '</span>';
      var src = (v.featured_image && v.featured_image.src) || QA.product.featured_image;
      if (src) qs('[data-qa-img]').src = imgUrl(src, 400);
      var add = qs('[data-qa-add]');
      add.disabled = !v.available;
      add.querySelector('span').textContent = v.available ? 'Add to basket' : 'Sold out';
      renderTiers();
    }
    function renderTiers() {
      var box = qs('[data-qa-tiers]'), list = tiers(), v = QA.variant;
      box.innerHTML = '';
      qs('.qa__label').hidden = !list.length;
      if (!list.length || !v) { QA.qty = 1; return; }
      list.forEach(function (t, i) {
        var each = Math.floor(v.price * (100 - t.off) / 100);
        var last = i === list.length - 1;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'qa__tier' + (t.q === QA.qty ? ' is-active' : '');
        b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', t.q === QA.qty ? 'true' : 'false');
        b.innerHTML = '<span class="qa__tier-q">' + t.q + (last && T.tierPlus ? '+' : '') + ' ' + unitWord(t.q) + '</span>' +
          (t.off ? '<span class="qa__tier-off">Save ' + t.off + '%</span>' : '<span class="qa__tier-off qa__tier-off--none">Standard</span>') +
          '<span class="qa__tier-each">' + formatMoney(each) + ' each</span>';
        b.addEventListener('click', function () { QA.qty = t.q; renderTiers(); });
        box.appendChild(b);
      });
    }
    function renderOptions() {
      var wrap = qs('[data-qa-options]'), p = QA.product;
      wrap.innerHTML = '';
      if (p.variants.length === 1 && p.options.length === 1 && p.variants[0].title === 'Default Title') return;
      p.options.forEach(function (name, oi) {
        var vals = [];
        p.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) === -1) vals.push(v.options[oi]); });
        var g = document.createElement('div'); g.className = 'qa__opt';
        g.innerHTML = '<div class="qa__label">' + esc(typeof name === 'string' ? name : name.name) + '</div>';
        var row = document.createElement('div'); row.className = 'qa__pills';
        vals.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button';
          b.className = 'qa__pill' + (QA.opts[oi] === val ? ' is-active' : '');
          b.textContent = val;
          var test = QA.opts.slice(); test[oi] = val;
          var tv = p.variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          if (!tv || !tv.available) b.classList.add('is-off');
          b.addEventListener('click', function () { QA.opts[oi] = val; QA.variant = findVariant(); renderOptions(); renderPrice(); });
          row.appendChild(b);
        });
        g.appendChild(row); wrap.appendChild(g);
      });
    }
    function productQtyInCart(cart) {
      return cart.items.filter(function (i) { return i.product_id === QA.product.id; }).reduce(function (a, i) { return a + i.quantity; }, 0);
    }
    function renderAdded(cart, addedQty) {
      var v = QA.variant, title = QA.product.title + (v && v.title !== 'Default Title' ? ' · ' + v.title : '');
      qs('[data-qa-added-line]').textContent = addedQty + ' × ' + title;
      qs('[data-qa-subtotal]').textContent = formatMoney(cart.total_price);
      // buy more, save more nudge
      var list = tiers(), have = productQtyInCart(cart), offer = qs('[data-qa-offer]');
      offer.innerHTML = '';
      if (list.length && v) {
        var current = null, next = null;
        list.forEach(function (t) { if (have >= t.q) current = t; else if (!next) next = t; });
        if (next) {
          var need = next.q - have;
          offer.innerHTML = '<div class="qa__offer-copy"><strong>Add ' + need + ' more, save ' + next.off + '%</strong>' +
            '<span>You have ' + have + ' in your basket. Buy ' + next.q + (next === list[list.length - 1] && T.tierPlus ? '+' : '') + ' and pay ' +
            formatMoney(Math.floor(v.price * (100 - next.off) / 100)) + ' each.</span></div>' +
            '<button type="button" class="btn btn--sm" data-qa-more="' + need + '">+ Add ' + need + '</button>';
          offer.querySelector('[data-qa-more]').addEventListener('click', function (e) {
            var btn = e.currentTarget; btn.disabled = true; btn.textContent = 'Adding…';
            addToCart(v.id, need).then(function (c) { renderAdded(c, addedQty + need); })
              .catch(function () { btn.disabled = false; btn.textContent = '+ Add ' + need; });
          });
          offer.hidden = false;
        } else if (current && current.off) {
          offer.innerHTML = '<div class="qa__offer-copy"><strong>You’re saving ' + current.off + '%</strong><span>Discount applied automatically at checkout.</span></div>';
          offer.hidden = false;
        } else { offer.hidden = true; }
      } else { offer.hidden = true; }
      // free shipping progress
      var th = T.freeShippingThreshold || 0, ship = qs('[data-qa-ship]');
      if (th) {
        var pct = Math.min(100, Math.round(cart.total_price / th * 100));
        ship.innerHTML = '<div class="ship-bar__text">' + (cart.total_price >= th ? 'Free shipping unlocked' : 'You’re <strong>' + formatMoney(th - cart.total_price) + '</strong> away from free shipping') +
          '</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div>';
        ship.hidden = false;
      } else ship.hidden = true;
      step('added');
    }
    function addToCart(id, qty) {
      return fetch((T.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket'); return j; }); })
        .then(function () { return refreshCart(); });
    }
    qs('[data-qa-add]').addEventListener('click', function (e) {
      var btn = e.currentTarget, v = QA.variant;
      if (!v) return;
      var label = btn.querySelector('span'), err = qs('[data-qa-error]');
      err.textContent = ''; btn.disabled = true; label.textContent = 'Adding…';
      addToCart(v.id, QA.qty).then(function (cart) { renderAdded(cart, QA.qty); })
        .catch(function (ex) { err.textContent = ex.message; })
        .finally(function () { btn.disabled = false; label.textContent = 'Add to basket'; });
    });

    document.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-quick-add]');
      if (!trig) return;
      e.preventDefault();
      var handle = trig.getAttribute('data-quick-add');
      trig.classList.add('is-loading');
      fetch((T.routes.root_url || '/') + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (p) {
          QA.product = p; QA.qty = 1;
          QA.unit = trig.getAttribute('data-quick-unit') || ''; QA.units = trig.getAttribute('data-quick-units') || '';
          QA.variant = p.variants.find(function (v) { return v.available; }) || p.variants[0];
          QA.opts = QA.variant.options.slice();
          qs('[data-qa-title]').textContent = p.title;
          qs('[data-qa-view]').href = p.url || trig.getAttribute('href');
          qs('[data-qa-img]').alt = p.title;
          qs('[data-qa-error]').textContent = '';
          renderOptions(); renderPrice(); step('choose'); openQA();
        })
        .catch(function () { window.location = trig.getAttribute('href'); })
        .finally(function () { trig.classList.remove('is-loading'); });
    });
  }

  /* Product tabs ------------------------------------------------------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('.tab', wrap);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) {
          var on = o === t;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(o.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !on;
            if (on) $$('.reveal', panel).forEach(function (el) { el.classList.add('is-in'); });
          }
        });
      });
    });
  });

  /* Shared lab result popup (cards, lab page) --------------------------- */
  var gLab = document.getElementById('LabModal');
  if (gLab) {
    var gImg = gLab.querySelector('[data-lab-modal-img]');
    var gTitle = gLab.querySelector('[data-lab-modal-title]');
    var baseTitle = gTitle ? gTitle.textContent : '';
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lab-src]');
      if (!b) return;
      e.preventDefault();
      var src = b.getAttribute('data-lab-src');
      var clean = src.split('?')[0].toLowerCase();
      if (!/\.(jpe?g|png|webp|gif|avif)$/.test(clean)) { window.open(src, '_blank', 'noopener'); return; }
      gImg.src = src;
      gImg.alt = (b.getAttribute('data-lab-name') || '') + ' lab test result';
      if (gTitle) gTitle.textContent = b.getAttribute('data-lab-name') ? b.getAttribute('data-lab-name') + ' \u00b7 ' + baseTitle : baseTitle;
      if (gLab.showModal) gLab.showModal(); else gLab.setAttribute('open', '');
    });
    gLab.addEventListener('click', function (e) {
      if (e.target === gLab || e.target.closest('[data-lab-close]')) gLab.close();
    });
  }

  /* Glass hero: cursor-reactive tilt, shine and parallax ----------------- */
  $$('[data-glass-hero]').forEach(function (hero) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var card = $('[data-tilt]', hero);
    var layers = $$('[data-depth]', hero);
    var raf = null, tx = 0, ty = 0, cx = 0, cy = 0;
    function frame() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      if (card) {
        card.style.transform = 'perspective(1000px) rotateY(' + (cx * 10).toFixed(2) + 'deg) rotateX(' + (-cy * 10).toFixed(2) + 'deg)';
        card.style.setProperty('--mx', (50 + cx * 50).toFixed(1) + '%');
        card.style.setProperty('--my', (50 + cy * 50).toFixed(1) + '%');
      }
      layers.forEach(function (l) {
        var d = parseFloat(l.getAttribute('data-depth')) || 0;
        l.style.translate = (cx * d).toFixed(1) + 'px ' + (cy * d).toFixed(1) + 'px';
      });
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) raf = requestAnimationFrame(frame); else raf = null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      hero.classList.add('is-hover');
      kick();
    });
    hero.addEventListener('pointerleave', function () { tx = 0; ty = 0; hero.classList.remove('is-hover'); kick(); });
  });

  /* Lab page search ------------------------------------------------------ */
  $$('[data-lab-search]').forEach(function (inp) {
    var grid = document.getElementById(inp.getAttribute('aria-controls'));
    var empty = document.querySelector('[data-lab-empty]');
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase(), shown = 0;
      $$('[data-lab-item]', grid).forEach(function (it) {
        var hit = !q || it.getAttribute('data-lab-item').indexOf(q) > -1;
        it.hidden = !hit; if (hit) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  });

  /* Collection sort ------------------------------------------------------ */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
  });
})();
